export const EMAIL_ERROR_MESSAGES = {
  genericError: 'Ha ocurrido un error, por favor vuelva a intentarloo.',
  duplicatedEmail: 'El email ya esta registrado para otro usuario',
};  